import * as echarts from 'echarts/core';

import {
    BarChart,
    // 系列类型的定义后缀都为 SeriesOption
    BarSeriesOption,
    LineChart,
    LinesChart,
    LineSeriesOption,
    PieChart,
    PieSeriesOption,
    MapChart,
    EffectScatterChart,
    MapSeriesOption,
    EffectScatterSeriesOption,
    LinesSeriesOption,
    ScatterChart,
    ScatterSeriesOption,
} from 'echarts/charts';

import {
    TitleComponent,
    // 组件类型的定义后缀都为 ComponentOption
    TitleComponentOption,
    TooltipComponent,
    TooltipComponentOption,
    GridComponent,
    GridComponentOption,
    // 数据集组件
    DatasetComponent,
    DatasetComponentOption,
    // 内置数据转换器组件 (filter, sort)
    TransformComponent,
    LegendComponent,
    LegendComponentOption,
    VisualMapComponent,
    VisualMapComponentOption,
    ToolboxComponent,
    ToolboxComponentOption,
} from 'echarts/components';

import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

// 通过 ComposeOption 来组合出一个只有必须组件和图表的 Option 类型
export type ECOption = echarts.ComposeOption<
    | BarSeriesOption
    | LineSeriesOption
    | PieSeriesOption
    | MapSeriesOption
    | TitleComponentOption
    | TooltipComponentOption
    | GridComponentOption
    | DatasetComponentOption
    | EffectScatterSeriesOption
    | LinesSeriesOption
    | LegendComponentOption
    | ScatterSeriesOption
    | VisualMapComponentOption
    | ToolboxComponentOption
>;

// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    LineChart,
    MapChart,
    PieChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
    EffectScatterChart,
    LinesChart,
    LegendComponent,
    ScatterChart,
    VisualMapComponent,
    ToolboxComponent,
]);

export default echarts;
